import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  LeaReportsAPI,
  LeaReportsData,
  LeaSubmissionMessageResponse,
  LEASubmissionsResponse,
} from "../../../api/lea";

export const fetchLeaReportsThunk = createAsyncThunk<
  LEASubmissionsResponse,
  { case_id: string },
  { rejectValue: string }
>("leaReports/fetch", async ({ case_id }, { rejectWithValue }) => {
  try {
    return await LeaReportsAPI.getLeaReports(case_id);
  } catch (error: any) {
    return rejectWithValue(error?.message || "Failed to fetch LEA reports");
  }
});

export const upsertLeaReportsThunk = createAsyncThunk<
  LeaSubmissionMessageResponse,
  { case_id: string; request: LeaReportsData },
  { rejectValue: string }
>("leaReports/upsert", async ({ case_id, request }, { rejectWithValue }) => {
  try {
    return await LeaReportsAPI.upsertLeaReports(case_id, request);
  } catch (error: any) {
    return rejectWithValue(error?.message || "Failed to upsert LEA reports");
  }
});
